'use client';

import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import ProgressDesktop from './progress-desktop';
import ProgressMobile from './progress-mobile';
const KhanoumiProgress = () => {
  const {
    isMobile
  } = useMobileDetect();
  if (isMobile) return <ProgressMobile />;
  return <ProgressDesktop data-sentry-element="ProgressDesktop" data-sentry-component="KhanoumiProgress" data-sentry-source-file="index.tsx" />;
};
export default KhanoumiProgress;